import React from "react";

import CountUp from "react-countup";

const Card = ({ title, value, icon }) => {
  const key = ["Dept", "University", "Location"];
  console.log(icon);

  return (
    <div className="shadow-xl pb-12 pt-8 px-8 bg-white rounded-md">
      <div className=" mt-5 text-center  ">
        <div className="text-5xl m-auto rounded-full  overflow-hidden border text-textColorSecondary inline-block mb-3">
          <img
            className=" rounded-full h-60 max-w-60 object-cover max-sm:w-full"
            src={icon}
            alt="img"
          />
        </div>
        <h5 className="text-textColorSecondary font-medium text-xl  max-sm:text-base ">
          {title}
        </h5>
        <div className=" text-textColorSecondary font-medium text-lg mt-4">
          {value === "1100" ? (
            <>
              <CountUp start={1} end={Number(value)} duration={10} />+
            </>
          ) : (
            <h6 className="">{value}</h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
